import { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import styled, { css } from 'styled-components'
import toast from 'react-hot-toast';
import Api from '../../utils/Api';
import ShareWithUser from '../../components/ShareWithUser';

const styles = css`
display: flex;
flex-wrap: wrap;
max-width: 600px;
width: 100%;
justify-content: center;
margin: 0 auto;
`
const GroupsShare = styled(({ className }) => {
  const [group, setGroup] = useState(null);
  const { id } = useParams();

  const fetchGroup = useCallback(async () => {
    const [error, group] = await Api.getGroup(id);
    if (error) {
      console.log(error);
      return toast.error(Api.error(error));
    }
    setGroup(group);
  }, [id]);

  useEffect(() => {
    fetchGroup();
  }, [fetchGroup]);

  return (
    <div className={className}>
      {group && <ShareWithUser groupId={id} onShare={fetchGroup} />}
    </div >
  )
})`${styles}`;

export default GroupsShare;
